const isGoogleMarketingPage = (pathname: string) => {
  return (
    pathname.includes('/google-certificates') ||
    pathname.includes('/google-learn') ||
    pathname.includes('/google-specializations')
  );
};

export default isGoogleMarketingPage;
